export const MSGS = {
  TIMECARD_APPROVAL_SUCCESS: "Timecard approved successfully",
  DAILY_TIMECARD_APPROVAL_SUCCESS: "Daily Timecard approved successfully",
  DAILY_TIMECARD_DISAPPROVAL_SUCCESS: "Daily Timecard disapproved successfully",
};

export default MSGS;
